module.exports = __webpack_public_path__ + "static/img/kong.93c56bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kong.png
// module id = Qf+M
// module chunks = 1